<style lang="scss" scoped>
  .toggle-up {
    transform: rotate(-90deg);
  }

  .toggle-down {
    transform: rotate(90deg);
  }

  .btn-bulldesk-transparent {
    border-radius: 14px;
    min-width: 200px;
    font-weight: 12px;
  }
</style>

<template>
  <button
    class="btn btn-bulldesk btn-bulldesk-transparent"
    type="button"
    @click.prevent="toggle()"
  >
    <IconMenu /><span class="ml-2">{{ __('Categorias') }}</span>
    <IconChevron
      class="ml-auto"
      :class="[toggled ? 'toggle-up' : 'toggle-down']"
    />
  </button>
</template>

<script>
export default {
  data: () => ({
    toggled: false,
  }),

  methods: {
    toggle () {
      this.toggled = ! this.toggled;

      Bus.$emit('toggleCategoryFilter');
    },
  },
};
</script>
